import React from 'react';
import './Style/WeightagePhysics2026.css';
import TopNavbar from '../../../home/TopNavbar';
import TopHeader from '../../../home/TopHeader';

const WeightagePhysics2026 = () => {
  // Physics Chapter Weightage Data
  const physicsData = [
    { chapter: 'Centre of Mass (Chapter -- System of Particles and Rotational Motion)', questions: 1, weightage: '1%' },
    { chapter: 'Gravitation', questions: 2, weightage: '3%' },
    { chapter: 'Kinematics (Chapters -- Motion in a straight line, Motion in a Plane)', questions: 1, weightage: '2%' },
    { chapter: 'Laws of Motion', questions: 3, weightage: '7%' },
    { chapter: 'Mechanical Properties of Solids & Fluids', questions: 2, weightage: '3%' },
    { chapter: 'Oscillations', questions: 1, weightage: '3%' },
    { chapter: 'Rotational motion (Chapter -- System of Particles and Rotational Motion)', questions: 1, weightage: '1%' },
    { chapter: 'Motion of System of Particles and Rigid Body', questions: 3, weightage: '7%' },
    { chapter: 'Units and Measurement', questions: 1, weightage: '2%' },
    { chapter: 'Waves', questions: 2, weightage: '4%' },
    { chapter: 'Work, Energy and Power', questions: 2, weightage: '4%' },
    { chapter: 'Kinetic Theory', questions: 1, weightage: '2%' },
    { chapter: 'Properties of Bulk Matter', questions: 1, weightage: '3%' },
    { chapter: 'Thermal Properties of Matter', questions: 1, weightage: '2%' },
    { chapter: 'Thermodynamics', questions: 3, weightage: '7%' },
    { chapter: 'Magnetic Effects of Current & Magnetism', questions: 3, weightage: '6%' },
    { chapter: 'Electric Charges & Fields', questions: 1, weightage: '2%' },
    { chapter: 'Electromagnetic Waves', questions: 1, weightage: '1%' },
    { chapter: 'Electrostatic Potential & Capacitance', questions: 1, weightage: '2%' },
    { chapter: 'Electrostatics', questions: 1, weightage: '3%' },
    { chapter: 'Alternating Currents', questions: 1, weightage: '3%' },
    { chapter: 'Current Electricity', questions: 3, weightage: '6%' },
    { chapter: 'Electromagnetic Induction', questions: 1, weightage: '2%' },
    { chapter: 'Semiconductor Electronics: Materials, Devices and Simple Circuits', questions: 3, weightage: '6%' },
    { chapter: 'Atoms & Nuclei', questions: 2, weightage: '5%' },
    { chapter: 'Dual Nature of Radiation and Matter', questions: 2, weightage: '4%' },
    { chapter: 'Ray Optics & Optical Instrument', questions: 3, weightage: '5%' },
    { chapter: 'Wave optics', questions: 2, weightage: '4%' },
  ];

  return (
    <div className="neetweightage-container">
     
       <TopNavbar name="Physics Weightage 2026" ></TopNavbar>
       <TopHeader name="Physics Weightage 2026" ></TopHeader>


      {/* Main Content Body */}
      <main className="neetweightage-content">
        <h2 className="neetweightage-main-title">Chapter-wise Weightage for NEET 2026</h2>

        <p className="neetweightage-paragraph">
          The NEET exam features a chapter-wise weightage system, crucial for students to understand the significance of each chapter in Biology, Chemistry, and Physics. Understanding the NEET chapter weightage 2026 is essential for strategic preparation and focusing on the most important chapters for NEET.
        </p>

        {/* Physics Section */}
        <section className="neetweightage-section">
          <h3 className="neetweightage-section-title">Physics Chapter-Wise Weightage</h3>
          <p className="neetweightage-paragraph">
            The NEET chapter-wise weightage for Physics is depicted in the table below. These are some of the most important chapters for NEET Physics that students preparing for NEET chapter weightage 2026 should prioritise:
          </p>

          <div className="neetweightage-table-wrapper">
            <table className="neetweightage-table">
              <thead>
                <tr>
                  <th>Physics Chapters and Topics</th>
                  <th className="neetweightage-th-center">Average Number of Questions</th>
                  <th className="neetweightage-th-center">Weightage (%)</th>
                </tr>
              </thead>
              <tbody>
                {physicsData.map((row, index) => (
                  <tr key={index}>
                    <td className="neetweightage-td-chapter">{row.chapter}</td>
                    <td className="neetweightage-td-center">{row.questions}</td>
                    <td className="neetweightage-td-center neetweightage-td-badge">
                      <span>{row.weightage}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>

   
    </div>
  );
};

export default WeightagePhysics2026;